import {
  ActivationStatus,
  VoucherTransactionStatus,
  VoucherTransactionType
} from '../../constants';

import {
  formatDate,
  isEqual
} from 'helpers';

export class RewardHistory {

  constructor(fields) {
    this.fields = fields;
  }

  mapToStandard() {

    return this.fields.flatMap((reward) => {

      const voucherStatus = ActivationStatus[reward.ACTIVATION_STATUS];

      if (voucherStatus !== ActivationStatus.Failed) {
        const paymentMethod = reward.paymentType;

        const rewardAdvanceHistory =
        reward.loanHistory?.find(h =>
          isEqual(h.transactionType, VoucherTransactionType.Advance)
        );
        const loanMaturity = rewardAdvanceHistory?.transactionDetail?.loanMaturity || 0;
        const feeAmount = rewardAdvanceHistory?.transactionDetail?.feeAmount?.value || 0;

        const repaymentHistory =
          reward.loanHistory?.find(h =>
            isEqual(h.transactionType, VoucherTransactionType.Repayment) &&
            isEqual(h.transactionDetail?.status, VoucherTransactionStatus.Success)
          );

        const hasBeenPayed =
          isEqual(paymentMethod, VoucherTransactionType.Advance)
            ? !!repaymentHistory
            : true;

        const outstandingAmount =
          hasBeenPayed
            ? 0
            : reward.GIFT_COST;

        return {
          voucherCode: reward.REDEMPTION_CODE,
          description: reward.PRIZE_DESCRIPTION,
          expiryDate: formatDate(reward.EXPIRY_DATE),
          paymentDue: formatDate(reward.DATE_ALLOCATED, loanMaturity),
          purchaseDate: formatDate(reward.DATE_ALLOCATED),
          voucherValue: parseFloat(reward.GIFT_CHARGE),
          voucherCost: parseFloat(reward.GIFT_COST),
          outstandingAmount: parseFloat(outstandingAmount),
          feeAmount: parseFloat(feeAmount),
          rewardSeq: reward.REWARD_SEQ,
          paymentMethod,
          voucherStatus,
          repaymentHistory
        };
      }

      return [];

    });

  }
}
